var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top"},[_c('div',{attrs:{"id":"nav"}},[_c('div',{attrs:{"id":"left"},on:{"click":_vm.back}},[_c('van-icon',{attrs:{"name":"arrow-left"}}),_vm._v(" 返回")],1),_c('div',{attrs:{"id":"title"}},[_vm._v(" 解忧密语 ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }